export const queryKeys = {
  settings: ["settings"],
  homeSections: ["homeSections"],
  about: ["about"],
  forums: ["forums"],
  forum: (slug) => ["forums", slug],
  forumPosts: (slug) => ["forumPosts", slug],
  forumDocuments: (slug) => ["forumDocuments", slug],
  events: ["events"],
  upcomingEvents: (limit) => ["events", "upcoming", limit],
  event: (slug) => ["events", slug],
  forumEvents: (forumSlug) => ["events", "forum", forumSlug],
  unitEvents: (unitSlug) => ["events", "unit", unitSlug],
  units: ["units"],
  featuredUnits: (limit) => ["units", "featured", limit],
  unit: (slug) => ["units", slug],
  unitPosts: (slug) => ["unitPosts", slug],
  sponsors: ["sponsors"],
  featuredSponsors: (limit) => ["sponsors", "featured", limit],
  banners: (placement) => ["banners", placement],
  activeForms: ["forms", "active"],
  memberCount: ["units", "totalMemberCount"],
  unitCount: ["units", "publishedCount"],
};
